import { styled } from '@mui/system';
import { Paper, Box, Button } from '@mui/material';

export const ContactFormContainer = styled('form')(({ theme }) => ({
  padding: theme.spacing(),
  marginTop: theme.spacing(),
  maxWidth: '700px',
  marginLeft: 'auto',
  marginRight: 'auto',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3),
    marginTop: theme.spacing(3)
  }
}));

export const ContactFormPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2, 1),
  display: 'grid',
  gridGap: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(3, 2)
  }
}));

export const ButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(),
  marginBottom: theme.spacing(),
  [theme.breakpoints.up('sm')]: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }
}));

export const ContactFormButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing()
}));
